import PropTypes from "prop-types";
import { formatLastSeen } from "utils/formatLastSeen";
import "./styles.less";

const UserStatusIndicator = ({
  online,
  lastSeen,
  showText = false,
  size = "md",
}) => {
  const isOnline = online === 1;

  return (
    <div className={`user-status-indicator ${size}`}>
      <span className={`status-dot ${isOnline ? "online" : "offline"}`} />
      {showText && (
        <span className="status-text">
          {isOnline ? "Đang hoạt động" : formatLastSeen(lastSeen)}
        </span>
      )}
    </div>
  );
};

UserStatusIndicator.propTypes = {
  online: PropTypes.number,
  lastSeen: PropTypes.string,
  showText: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

UserStatusIndicator.defaultProps = {
  online: 0,
  lastSeen: null,
  showText: false,
  size: "md",
};

export default UserStatusIndicator;
